import HttpService from '@/services/http/http.service';
import { ToastsViewModel, Toast, ToastViewModel, GenericViewModel } from '@/types/apiServerContract';

const API_PATH = 'toast/';

export class ToastApi {
    public static async GetToasts(): Promise<ToastsViewModel> {
        return HttpService.Get<ToastsViewModel>(API_PATH + 'GetToasts');
    }

    public static async SaveToast(toast: Toast): Promise<ToastViewModel> {
        return HttpService.Post<ToastViewModel>(API_PATH + 'SaveToast', toast);
    }

    public static async DeleteToast(id: string): Promise<GenericViewModel<boolean>> {
        return HttpService.Get<GenericViewModel<boolean>>(API_PATH + 'DeleteToast', {
            id
        });
    }
}
